import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);


class IntroTitlePage extends React.Component {

	constructor(props) {
		super(props);
    this.state = {};
	}

	render() {
		return <div className={'IntroTitlePage pageContent'}>
		</div>;
	}
}
export default IntroTitlePage;

function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

export const IntroTitlePageContainer = connect(
  mapStateToProps,
  allActionCreators
)(IntroTitlePage);


// WEBPACK FOOTER //
// ./src/components/views/page/IntroTitlePage.jsx